const FAQSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 24 24',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 18H11V16H13V18H12ZM14.07 11.25L13.17 12.17C12.45 12.9 12 13.5 12 15H10V14.5C10 13.4 10.45 12.4 11.17 11.67L12.41 10.41C12.78 10.05 13 9.55 13 9C13 7.9 12.1 7 11 7C9.9 7 9 7.9 9 9H7C7 6.79 8.79 5 11 5C13.21 5 15 6.79 15 9C15 10.1 14.55 10.9 14.07 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default FAQSvg;
